var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("legend", [_vm._v("Project")]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("div", { staticClass: "toggle-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.isOpportunity,
                    expression: "formData.isOpportunity",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "toggle",
                attrs: {
                  id: "is-opportunity",
                  name: "is opportunity",
                  type: "radio",
                  required: "",
                },
                domProps: {
                  value: true,
                  checked: _vm._q(_vm.formData.isOpportunity, true),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.formData, "isOpportunity", true)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "toggle", attrs: { for: "is-opportunity" } },
                [_vm._v("Yes")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.isOpportunity,
                    expression: "formData.isOpportunity",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "toggle",
                attrs: {
                  id: "is-not-opportunity",
                  name: "isOpportunity",
                  type: "radio",
                  required: "",
                },
                domProps: {
                  value: false,
                  checked: _vm._q(_vm.formData.isOpportunity, false),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.formData, "isOpportunity", false)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "toggle", attrs: { for: "is-not-opportunity" } },
                [_vm._v("No")]
              ),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "form__label" }, [
              _vm._v("Is this an existing opportunity?"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("isOpportunity"))),
            ]),
          ]),
          _vm._v(" "),
          _vm.formData.isOpportunity
            ? _c("FormControlOpportunity", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  name: "opportunity",
                  label: "Select existing opportunity",
                },
                model: {
                  value: _vm.formData.opportunity,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "opportunity", $$v)
                  },
                  expression: "formData.opportunity",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("FormControlUser", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { name: "lead", label: "Select lead user" },
            model: {
              value: _vm.formData.lead,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "lead", $$v)
              },
              expression: "formData.lead",
            },
          }),
          _vm._v(" "),
          _c("FormControlUser", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { name: "team", label: "Additional users", multiple: true },
            model: {
              value: _vm.formData.team,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "team", $$v)
              },
              expression: "formData.team",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Save & Continue")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }